import sheet from '../assets/images/sheet.png'

const image = new Image()
image.src = sheet

const BURROW_TIME = 20

const WormSheet = {
  HEAD_null: [7, 12],
  HEAD_LEFT: [4, 13],
  HEAD_RIGHT: [3, 15],
  HEAD_UP: [4, 15],
  HEAD_DOWN: [4, 14],
  
  BODY_LEFT: [5, 13],
  BODY_RIGHT: [2, 15],
  BODY_UP: [5, 14],
  BODY_DOWN: [5, 14],

  ORIG_LEFT: [7, 13],
  ORIG_RIGHT: [0, 15],
  ORIG_UP: [7, 15],
  ORIG_DOWN: [7, 14],

  TAIL_RIGHT: [1, 15],
  TAIL_LEFT: [6, 13],
  TAIL_UP: [6, 15],
  TAIL_DOWN: [6, 14],
}

const Worm = (x, y) => kontra.sprite({
  x,
  y,
  origX: x,
  origY: y,
  dir: null,
  burrowTimer: BURROW_TIME,
  burrowed: false,
  length: 5,
  trail: [],

  update() {
    if (this.burrowTimer > 0) {
      this.burrowTimer--
    } else {
      if (!this.burrowed) {
        this.dir = pickRandom(LEFT, RIGHT, UP, DOWN)
        this.burrowed = true
        this.trail.unshift({ x: this.x, y: this.y })
      }

      const [nextX, nextY] = getAtDir(this.x, this.y, this.dir)
      if (map.getTile(0, toGrid(nextX), toGrid(nextY)).type === Tiles.DIRT) {
        this.x = nextX
        this.y = nextY
      }

      this.trail.unshift({ x: this.x, y: this.y })

      while (this.trail.length > this.length) {
        this.trail.pop()
      }
    }
  },

  render() {
    if (this.burrowTimer > 1) {
      return
    } else {
      let sx, sy

      // draw trail
      this.trail.forEach((cell, i) => {
        if (i === 0) {
          return
        }

        if (cell.x === this.origX && cell.y === this.origY) {
          ;[sx, sy] = WormSheet[`ORIG_${this.dir}`]
        } else if (i === this.trail.length - 1) {
          ;[sx, sy] = WormSheet[`TAIL_${this.dir}`]
        } else {
          ;[sx, sy] = WormSheet[`BODY_${this.dir}`]
        }

        this.context.drawImage(
          image,
          sx * 16, sy * 16, 16, 16,
          cell.x, cell.y, 16, 16,
        )
      })

      ;[sx, sy] = WormSheet[`HEAD_${this.dir}`]

      this.context.drawImage(
        image,
        sx * GRID, sy * GRID, GRID, GRID,
        this.x, this.y, GRID, GRID,
      )
    }
  }
})

export default Worm